export const generateEnhancePrompt = (interactionGoal, businessContext) => {
  return `Phân tích và tăng cường chi tiết cho mục tiêu tương tác dưới đây với các yêu cầu sau:

- Làm rõ mục tiêu cụ thể của cuộc tương tác (bán hàng/tư vấn/đàm phán).
- Xác định các bước tiếp cận và thuyết phục đối tượng.
- Đề xuất các kỹ thuật giao tiếp phù hợp.
- Dự đoán các phản ứng có thể của đối tượng và cách xử lý.
- Đưa ra các chỉ số đo lường thành công của cuộc tương tác.
- Đề xuất các phương án dự phòng nếu tương tác không thành công.

Bối cảnh kinh doanh:
${businessContext}

Mục tiêu tương tác hiện tại:
${interactionGoal}

Yêu cầu đầu ra:
- Giữ nguyên mục tiêu chính của cuộc tương tác.
- Đề xuất các chiến thuật và kỹ năng tương tác cụ thể.
- Tập trung vào cách thức tiếp cận và thuyết phục đối tượng.
- Trình bày ngắn gọn, rõ ràng và dễ hiểu.
- Trình bày bằng tiếng Việt.
- Không sử dụng các từ ngữ phức tạp, khó hiểu.
- Không sử dụng markdown format.
- Đảm bảo phù hợp với bối cảnh kinh doanh.

Vui lòng cung cấp phiên bản chi tiết về cách thức tương tác hiệu quả để đạt được mục tiêu trên.`;
};